<template>
  <li class="notification-container rounded text-center">
    <div>
      <div class="pb-2 lead-alerts-heading border-bottom">
        <span class="d-none d-md-block">Lead Alerts</span>
        <slot name="pane-header" />
      </div>
      <spinner v-if="busy" display-loading="true" />
      <template v-else>
        <div v-if="hasNotifications" class="px-4">
          <div class="row">
            <div class="col d-flex justify-content-center my-3 lead-alerts-action">
              <b-button variant="outline-secondary" size="sm" class="mx-2" @click.prevent.stop="clearExpired">
                Clear Sold
              </b-button>
              <b-button variant="outline-secondary" size="sm" class="mx-2" @click.prevent.stop="clear">
                Clear All
              </b-button>
            </div>
          </div>
          <template v-if="notifications.priority">
            <span class="h4">Priority Leads</span>
            <div v-for="(group, groupName) in notifications.priority" :key="groupName">
              <div v-if="groupName !== 'today'" class="h5 text-capitalize text-left mt-3 mb-2">
                {{ groupName }}
              </div>
              <lead-notification
                v-for="(lead, index) in group"
                :key="index"
                :lead="lead"
                @hide="clearSingle($event)"
              />
            </div>
          </template>
          <template v-if="notifications.priorityExpired">
            <div class="h4">
              Priority Expired
            </div>
            <div v-for="(group, groupName) in notifications.priorityExpired" :key="groupName">
              <div v-if="groupName !== 'today'" class="h5 text-capitalize text-left mt-3 mb-2">
                {{ groupName }}
              </div>
              <lead-notification
                v-for="(lead, index) in group"
                :key="index"
                :lead="lead"
                @hide="clearSingle($event)"
              />
            </div>
          </template>
          <template v-if="notifications.soldOut">
            <span class="h4">Sold Out</span>
            <div v-for="(group, groupName) in notifications.soldOut" :key="groupName">
              <div v-if="groupName !== 'today'" class="h5 text-capitalize text-left mt-3 mb-2">
                {{ groupName }}
              </div>
              <lead-notification
                v-for="(lead, index) in group"
                :key="index"
                :lead="lead"
                @hide="clearSingle($event)"
              />
            </div>
          </template>
        </div>
        <div v-else class="d-flex justify-content-center align-items-center py-5 my-5">
          <span class="no-leads">You have no lead alerts currently.</span>
        </div>
      </template>
      <div v-if="!hasNotifications" class="col-12">
        <router-link class="h5 d-flex align-items-center justify-content-center my-3" :to="{name: 'lead-alerts'}" @click.native="closePane">
          <font-awesome-icon icon="cog" transform="shrink-3" />
          <span class="ml-1">Check your Lead Alert settings</span>
        </router-link>
      </div>
    </div>
  </li>
</template>

<script>
import LeadNotification from "@/components/cards/LeadNotification";
import OlderThanNow from "@/imports/mixins/olderThanNow";
import Spinner from "@/components/animation/Spinner";

export default {
  name: "LeadNotifications",
  components: {Spinner, LeadNotification},
  mixins: [OlderThanNow],
  data: function() {
    return {
      busy: false,
    }
  },
  computed: {
    notifications: function () {
      return this.sanitize(this.$store.state.leads.LEAD_NOTIFICATIONS);
    },
    hasNotifications: function() {
      return Object.keys(this.notifications).length > 0;
    },
    allLeads: function() {
      let leads = [];
      Object.values(this.notifications).forEach((group) => {
        Object.values(group).forEach((subGroup) => {
          subGroup.forEach((lead) => {leads.push(lead.id)});
        });
      });

      return leads;
    },
    expiredLeads: function() {
      let leads = [];
      Object.values(this.notifications).forEach((group) => {
        Object.values(group).forEach((subGroup) => {
          subGroup.forEach((lead) => {
            if (lead.enquiry.sold > 2) {
              leads.push(lead.id);
            }
          });
        });
      });

      return leads;
    }
  },
  methods: {
    clear: function () {
      this.busy = true;
      this.$store.dispatch('clearLeadNotifications', {leads: this.allLeads, callback: () => {
        this.busy = false;
      }});
    },
    clearExpired: function () {
      this.busy = true;
      this.$store.dispatch('clearLeadNotifications', {leads: this.expiredLeads, callback: () => {
        this.busy = false;
      }});
    },
    clearSingle: function(lead) {
      this.busy = true;
      this.$store.dispatch('clearLeadNotifications', {leads: [lead.id], callback: () => {
        this.busy = false;
      }});
    },
    markRead: function() {
      this.$store.dispatch('markLeadNotificationsRead', this.allLeads);
    },
    closePane: function() {
      this.$emit('close');
    },
    sanitize: function(notifications) {
      let cleanVersion = {};
      Object.keys(notifications.priority).forEach((key) => {
        if(key !== '' && notifications.priority[key].length !== 0) {
          cleanVersion.priority[key] = notifications.priority[key];
        }
      });
      Object.keys(notifications.priorityExpired).forEach((key) => {
        if(key !== '' && notifications.priorityExpired[key].length !== 0) {
          cleanVersion.priorityExpired[key] = notifications.priorityExpired[key];
        }
      });
      Object.keys(notifications.soldOut).forEach((key) => {
        if(key !== '' && notifications.soldOut[key].length !== 0) {
          cleanVersion.soldOut[key] = notifications.soldOut[key];
        }
      });

      return cleanVersion;
    }
  },
}
</script>

<style scoped lang="scss">
  .notification-container {
    @include media-breakpoint-up(md) {
      max-height: 60vh;
    }
    @include media-breakpoint-down(sm){
      height: 90vh;
    }
    overflow-y: auto;
    .lead-alerts-action {
      .btn {
        min-width: 105px;
      }
    }
    @include media-breakpoint-up(md) {
      min-width: 430px;
      box-shadow: $box-shadow-tertiary;
    }
    @include media-breakpoint-down(sm) {
      .lead-alerts-heading {
        margin-top: 5px;
      }
    }
    &::v-deep {
      .b-toast {
        @include media-breakpoint-up(md) {
          max-width: 500px !important;
        }
        .toast{
          margin-top: 25px;
          max-width: 500px !important;
          .toast-body {
            padding: 0 0.75rem;
          }
        }
        &-warning,
        &-danger {
          .toast-body {
            .inner-wrap {
              padding-top: 10px;
            }
          }
        }
      }
    }
  }

  .no-leads {
    position: relative;

    &:after {
      content: '\200C';
      height: 2px;
      background-color: $border-color;
      width: 110px;
      position: absolute;
      bottom: -10px;
      left: 0;
      right: 0;
      margin-left: auto;
      margin-right: auto;
    }
  }
</style>
